module.exports = __webpack_public_path__ + "img/Icon_Informes_del_caso_hover.c2d9b4fd.svg";